import React from "react";
import LinkedShowLines from "./LinkedShowElement";
import { routes } from "utilities/routing/generatedRoutes";
import { Dot } from "components/Dot";
import { ShowPreview } from "components/PreviewPanel/Show/ShowPreviewPanel";

interface Props {
  shows: server.dto.LinkedShow[]
  onChange: () => void
}

const LinkedShowsList = (props: Props) => {
  const { shows, onChange } = props;

  // Workaround for train detail page, as there we don't have preview panels
  const onClick = (showId: number) => {
    if (document.getElementsByClassName("preview-panel-root").length === 0) {
      window.location.href = routes.show_Detail(showId).absolute;
    }
  }

  return <div className="flex-column gap-small">
    {shows.map(show => (
      <ShowPreview
        canEdit
        onChange={onChange}
        showId={show.showId}
        key={show.showId}
        trigger={<a className="flex gap-small linked-show-row linked-show-link regular" onClick={() => onClick(show.showId)} style={{ cursor: "pointer", textDecoration: "none" }}>
          <div>
            <Dot color={show.status.hexColor} />
          </div>
          <div>
            <LinkedShowLines {...show} format={"regular"} />
          </div>
        </a>}
      />))
    }
  </div >;
};

export default LinkedShowsList;
